"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTime = void 0;
const DateUtils = __importStar(require("../utils"));
const DateBase_1 = require("./DateBase");
const GregorianDate_1 = require("./GregorianDate");
const LocalTime_1 = require("./LocalTime");
/**
 * Represents a specific moment in time.
 */
class DateTime extends DateBase_1.DateBase {
    /**
     * Creates a new instance of the DateTime class.
     *
     * @param year - The year value.
     * @param month - The month value.
     * @param day - The day value.
     * @param hour - (Optional) The hour value, default is 0.
     * @param minute - (Optional) The minute value, default is 0.
     * @param second - (Optional) The second value, default is 0.
     * @param millisecond - (Optional) The millisecond value, default is 0.
     *
     * @throws {Error} - If the date or time values are invalid.
     */
    constructor(year, month, day, hour = 0, minute = 0, second = 0, millisecond = 0) {
        super();
        /**
         * Creates a new instance of the DateTime class from a JS Date object.
         *
         * @param date - The JS Date object.
         *
         * @returns {DateTime} - The DateTime instance representing the same date and time as the input date.
         */
        this.fromDate = (date) => _a.fromDate(date);
        /**
         * Creates a new instance of the DateTime class from an ISO-8601 string.
         *
         * @param str - The ISO-8601 string representation of the date and time.
         *
         * @returns {DateTime} - The DateTime instance representing the date and time parsed from the input string.
         *
         * @throws {Error} - If the input string is not in the expected ISO 8601 format.
         */
        this.fromISOString = (str) => _a.fromISOString(str);
        /**
         * Returns a JS Date object representing the DateTime instance.
         *
         * @returns {Date} - The JavaScript Date object representing the same date and time as the DateTime instance.
         */
        this.toDate = () => new Date(this.date.year, this.date.month - 1, this.date.day, this.time.hour, this.time.minute, this.time.second, this.time.millisecond);
        /**
         * Checks if the current DateTime instance is equal to the specified DateTime instance, including the time.
         *
         * @param dateTime - The DateTime instance to compare.
         *
         * @returns {boolean} - True if the current DateTime instance is equal to the specified DateTime, false otherwise.
         */
        this.isEqual = (dateTime) => this.date.isEqualDate(dateTime.date) && this.time.isEqual(dateTime.time);
        /**
         * Checks if the current DateTime instance is equal to the specified DateTime instance, including the time.
         *
         * @param dateTime - The DateTime instance to compare.
         * @returns {boolean} - True if the current DateTime instance is equal to the specified DateTime, false otherwise.
         */
        this.isEqualTime = (dateTime) => this.time.isEqual(dateTime.time);
        /**
         * Checks if the current DateTime instance has the same date (year, month, and day) as the specified DateTime instance, ignoring the time.
         *
         * @param dateTime - The DateTime instance to compare.
         * @returns {boolean} - True if the current DateTime instance has the same date as the specified DateTime instance, false otherwise.
         */
        this.isEqualDate = (dateTime) => this.date.isEqualDate(dateTime.date);
        /**
         * Checks if the current DateTime instance is in the same year as the specified DateTime.
         *
         * @param dateTime - The DateTime instance to compare.
         *
         * @returns {boolean} - True if the current DateTime instance is in the same year as the specified DateTime, false otherwise.
         */
        this.isThisYear = (dateTime) => this.date.isThisYear(dateTime.date);
        /**
         * Checks if the current DateTime instance is in the same month as the specified DateTime.
         *
         * @param dateTime - The DateTime instance to compare.
         *
         * @returns {boolean} - True if the current DateTime instance is in the same month as the specified DateTime, false otherwise.
         */
        this.isThisMonth = (dateTime) => this.date.isThisMonth(dateTime.date);
        /**
         * Gets the name of the month based on the month index.
         *
         * @param monthFormat - The format of the month name.
         *
         * @returns {string} - The name of the month.
         */
        this.getMonthNameByMonthIndex = (monthFormat) => this.date.getMonthNameByMonthIndex(monthFormat);
        this.date = new GregorianDate_1.GregorianDate(year, month, day);
        this.time = new LocalTime_1.LocalTime(hour, minute, second, millisecond);
    }
}
exports.DateTime = DateTime;
_a = DateTime;
/**
 * Creates a new instance of the DateTime class from a JS Date object.
 *
 * @param date - The JS Date object.
 *
 * @returns {DateTime} - The DateTime instance representing the same date and time as the input date.
 */
DateTime.fromDate = (date) => new _a(date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
/**
 * Creates a new instance of the DateTime class from an ISO-8601 string.
 *
 * @param str - The ISO-8601 string representation of the date and time.
 *
 * @returns {DateTime} - The DateTime instance representing the date and time parsed from the input string.
 *
 * @throws {Error} - If the input string is not in the expected ISO 8601 format.
 */
DateTime.fromISOString = (str) => {
    const UTCms = DateUtils.ISO8601ToUTCms(str);
    if (Number.isNaN(UTCms)) {
        throw new Error(`Expected ISO 8601 format date, got ${str}`);
    }
    return _a.fromDate(new Date(UTCms));
};
//# sourceMappingURL=DateTime.js.map